export const sendPostRequest = async (functions: any, to: string[], subject: string, body: string) => {
  const mailType = process.env.REACT_APP_MAIL_TYPE || 'ses'

  if (mailType === 'ses') {
    const data = {
      to: to,
      subject: subject,
      body: body,
    }
    try {
      // Call Firebase Function
      const result = await functions(['sendEmail', data])
      return result
    } catch (error) {
      console.error('SES Mail Error:', error)
      throw error
    }
  }

  // Backup PHP Implementation
  let url = String(process.env.REACT_APP_MAIL_HOST)
  const key = String(process.env.REACT_APP_MAIL_KEY)

  const data = {
    key: key,
    to: to,
    cc: [],
    subject: subject,
    body: body,
  }

  try {
    // Try without Content-Type header first (CORS-friendly)
    let response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    })

    // If that fails, try with Content-Type header
    if (!response.ok && response.status === 0) {
      console.log('Trying with Content-Type header')
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const responseText = await response.text() // Get string response
    return responseText
  } catch (error) {
    console.error('PHP Mail Error:', error)
    throw error
  }
}